import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator, enableNetwork, disableNetwork } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

// const app을 export const app으로 수정합니다.
export const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
// Shared role state is isolated from finance records in its own Firestore database.
export const accessDb = getFirestore(app, 'bfgc-access');
export const storage = getStorage(app);

// 개발 환경에서 에뮬레이터 연결 (개발 시에만 사용)
// 에뮬레이터 사용을 원하면 아래 주석을 해제하세요
/*
if (import.meta.env.DEV) {
  try {
    // Firestore 에뮬레이터 연결
    connectFirestoreEmulator(db, 'localhost', 8080);
    
    // Auth 에뮬레이터 연결
    connectAuthEmulator(auth, 'http://localhost:9099');
    
    console.log('Firebase 에뮬레이터에 연결되었습니다.');
  } catch (error) {
    console.warn('Firebase 에뮬레이터 연결에 실패했습니다:', error);
  }
}
*/

// 네트워크 상태 감지 및 오프라인 모드 처리
let isOffline = false;

// 네트워크 연결 상태 감지
window.addEventListener('online', () => {
  isOffline = false;
  enableNetwork(db).catch(err => {
    console.error('네트워크 재연결 실패:', err);
  });
});

window.addEventListener('offline', () => {
  isOffline = true;
  disableNetwork(db).catch(err => {
    console.error('오프라인 모드 전환 실패:', err);
  });
});